import { ApiError } from '../../api/errors';

/*
 * Файл із відповіді POST-операції (експорт CSV конструктора звітів, вивантаження для фінансової програми):
 * той самий сеанс (cookie, X-ERS-Client: web), ключ ідемпотентності, помилка сервера — ApiError з поясненням
 * українською. Ім’я файлу — з Content-Disposition (filename* має перевагу) або типове. Повертає заголовки
 * відповіді: деякі операції передають у них ідентифікатор запису журналу (напр. X-ERS-Exchange-Run).
 */

function fileNameOf(res: Response, fallback: string): string {
  const cd = res.headers.get('content-disposition') ?? '';
  const star = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  const plain = /filename="?([^";]+)"?/i.exec(cd);
  try {
    if (star?.[1]) return decodeURIComponent(star[1]);
    if (plain?.[1]) return plain[1];
  } catch {
    return fallback;
  }
  return fallback;
}

/** Зберегти вміст як файл у браузері. */
export function saveBlob(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function downloadPost(path: string, body: unknown, fallbackName: string): Promise<{ headers: Headers; fileName: string }> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'x-ers-client': 'web',
        accept: 'text/csv, application/json',
        'content-type': 'application/json',
        'idempotency-key': crypto.randomUUID(),
      },
      body: JSON.stringify(body ?? {}),
    });
  } catch {
    throw ApiError.network();
  }
  if (!res.ok) {
    let problem: unknown = undefined;
    try {
      problem = await res.json();
    } catch {
      problem = undefined;
    }
    throw ApiError.fromResponse(res, problem);
  }
  const blob = await res.blob();
  const fileName = fileNameOf(res, fallbackName);
  saveBlob(blob, fileName);
  return { headers: res.headers, fileName };
}
